import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Paths from "routes/Paths";

import LineIcon from "./LineIcon";

import navStyles from "../HomePage.module.css";
import styles from "./SidebarNotifications.module.css";

type SidebarNotificationsProps = {
	/** Owned by the sidebar so the collapsed phone bar can flag the same unread state. */
	unreadCount: number;
};

/** Sidebar entry linking to the notifications page, with an unread-count badge. */
const SidebarNotifications = ({ unreadCount }: SidebarNotificationsProps) => {
	const { t } = useTranslation("homePage");

	return (
		<Link className={navStyles.navItem} to={Paths.notifications}>
			<LineIcon name="bell" />
			<span>{t("view.notifications")}</span>
			{unreadCount > 0 && <span className={styles.badge}>{unreadCount > 9 ? "9+" : unreadCount}</span>}
		</Link>
	);
};

export default SidebarNotifications;
